import { useState, useEffect } from "react"

/** Returns true when the primary pointer is coarse (touch/stylus). Reactive to device changes. */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(() =>
    typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches
  )
  useEffect(() => {
    const mql = window.matchMedia("(pointer: coarse)")
    setCoarse(mql.matches)
    const handler = () => setCoarse(mql.matches)
    mql.addEventListener("change", handler)
    return () => mql.removeEventListener("change", handler)
  }, [])
  return coarse
}
